import { useMutation, useQueryClient } from "react-query";

import { getAppointmentsV2QueryKeyPrefix } from "api/services/appointment/hooks/useGetAppointmentsV2";
import type { AppointmentV2, PostAppointmentV2ManagerArgs } from "api/services/appointment/schemas/appointment_v2";
import { useApiClient } from "api/useApiClient";

export const usePostAppointmentV2Manager = () => {
  const client = useApiClient();
  const queryClient = useQueryClient();

  return useMutation<AppointmentV2, Error, PostAppointmentV2ManagerArgs>({
    mutationFn: args => client.postAppointmentV2Manager(args),
    onSuccess() {
      queryClient.invalidateQueries([getAppointmentsV2QueryKeyPrefix]);
    },
  });
};
